const getNotificationsItems = (notifications) => {
  return notifications.reduce((result, notification) => {
    if (notification.details.composites.length) {
      return {
        ...result,
        composites: [...result.composites, ...notification.details.composites],
      };
    }

    if (notification.details.paymarket) {
      return {
        ...result,
        paymarkets: [...result.paymarkets, notification.details.paymarket]
      }
    }

    return result;
  }, { paymarkets: [], composites: []});
}

export function getCompositesFromNotifications(currentComposites, notifications) {
  const { paymarkets, composites } = getNotificationsItems(notifications)

  return currentComposites.filter((composite) => {
    if (composites.includes(composite.id)) {
      return true;
    }
    return paymarkets.includes(composite.paymarketId);
  }).map(({ id }) => id);
}
